import { useCallback, useLayoutEffect, useRef, useState } from "react";

const DEFAULT_MIN_HEIGHT = 320;

export function useGridContainer({ fixedAreaRef, minHeight = DEFAULT_MIN_HEIGHT, bottomOffset = 0 } = {}) {
    const containerRef = useRef(null);
    const [height, setHeight] = useState(minHeight);

    const recalculateHeight = useCallback(() => {
        if (typeof window === "undefined") return;

        const container = containerRef.current;
        const top = container ? container.getBoundingClientRect().top : 0;
        const nextHeight = Math.max(minHeight, Math.floor(window.innerHeight - top - bottomOffset));
        setHeight(nextHeight);
    }, [bottomOffset, minHeight]);

    useLayoutEffect(() => {
        recalculateHeight();
        window.addEventListener("resize", recalculateHeight);

        const ResizeObserverImpl = window.ResizeObserver;
        const resizeObserver = ResizeObserverImpl ? new ResizeObserverImpl(recalculateHeight) : null;
        if (resizeObserver) {
            if (containerRef.current) resizeObserver.observe(containerRef.current);
            if (fixedAreaRef?.current) resizeObserver.observe(fixedAreaRef.current);
        }

        return () => {
            window.removeEventListener("resize", recalculateHeight);
            resizeObserver?.disconnect();
        };
    }, [fixedAreaRef, recalculateHeight]);

    return {
        containerRef,
        height,
        recalculateHeight,
    };
}
